import createIcon from '../../createIcon';

/**
 * @component @name AirportShuttle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgNUgzQzEuOSA1IDEgNS44OSAxIDdWMTZIM0MzIDE3LjY1IDQuMzQgMTkgNiAxOUM3LjY2IDE5IDkgMTcuNjUgOSAxNkgxNC41QzE0LjUgMTcuNjUgMTUuODQgMTkgMTcuNSAxOUMxOS4xNiAxOSAyMC41IDE3LjY1IDIwLjUgMTZIMjNWMTFMMTcgNVpNMyAxMVY3SDdWMTFIM1pNNiAxNy41QzUuMTcgMTcuNSA0LjUgMTYuODMgNC41IDE2QzQuNSAxNS4xNyA1LjE3IDE0LjUgNiAxNC41QzYuODMgMTQuNSA3LjUgMTUuMTcgNy41IDE2QzcuNSAxNi44MyA2LjgzIDE3LjUgNiAxNy41Wk0xMyAxMUg5VjdIMTNWMTFaTTE3LjUgMTcuNUMxNi42NyAxNy41IDE2IDE2LjgzIDE2IDE2QzE2IDE1LjE3IDE2LjY3IDE0LjUgMTcuNSAxNC41QzE4LjMzIDE0LjUgMTkgMTUuMTcgMTkgMTZDMTkgMTYuODMgMTguMzMgMTcuNSAxNy41IDE3LjVaTTE1IDExVjdIMTZMMjAgMTFIMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirportShuttle = createIcon('AirportShuttle', [
  [
    'path',
    {
      d: 'M17 5H3C1.9 5 1 5.89 1 7V16H3C3 17.65 4.34 19 6 19C7.66 19 9 17.65 9 16H14.5C14.5 17.65 15.84 19 17.5 19C19.16 19 20.5 17.65 20.5 16H23V11L17 5ZM3 11V7H7V11H3ZM6 17.5C5.17 17.5 4.5 16.83 4.5 16C4.5 15.17 5.17 14.5 6 14.5C6.83 14.5 7.5 15.17 7.5 16C7.5 16.83 6.83 17.5 6 17.5ZM13 11H9V7H13V11ZM17.5 17.5C16.67 17.5 16 16.83 16 16C16 15.17 16.67 14.5 17.5 14.5C18.33 14.5 19 15.17 19 16C19 16.83 18.33 17.5 17.5 17.5ZM15 11V7H16L20 11H15Z',
      key: '47oy6h',
    },
  ],
]);

export default AirportShuttle;
